// Link social e contatti — modifica qui in un unico punto.
export const REDEEM_URL = "http://t.me/TONYWIN10"; // usato solo dal bottone "Riscatta il tuo premio"

export const SOCIAL = {
  headline: "SEGUIMI SU TUTTI I SOCIAL PER NON PERDERTI NESSUNA NOVITÀ",
  links: [
    { key: "telegram_channel", label: "Canale Telegram", platform: "telegram", url: "https://t.me/+vTyQSJG6CKgwYjU0" },
    { key: "instagram", label: "Instagram", platform: "instagram", url: "https://www.instagram.com/tony_win_10?stkn=MjdzZmd3Y2x0cmRx" },
    { key: "tiktok", label: "TikTok", platform: "tiktok", url: "https://tiktok.com/@ilmagoditiktok5" },
  ],
};
